import apiSlice from "./apiSlice";
const contractorSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getContractor: builder.query({
            query: () => `Contractors`,
        }),
    }),
})

export const { useGetContractorQuery } = contractorSlice
